import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { Subscription } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import moment from 'moment';
import BusinessRestServices from "../../services/business-rest.service";
import Config from "../../utils/config.service";
import DialogServices from "../../services/dialog.service";
import RestService from "../../services/core-rest.service";

@Component({
  standalone: true,
  selector: 'table-created-training-program',
  templateUrl: './table-created-training-program.component.html',
  imports: [
    CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, TranslatePipe, RouterLink,
    ItemNoContentComponent, LoaderOverlayComponent, FormsModule, InputDatepickerNewComponent
  ]
})
export class TableCreatedTrainingProgramComponent implements OnInit, OnDestroy {
  private angularHelperService: AngularHelperService = inject(AngularHelperService);
  private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
  private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
  private config: Config = inject(Config);
  private dialogServices: DialogServices = inject(DialogServices);
  private restService: RestService = inject(RestService);
  private router: Router = inject(Router);


  @Input() pageSize: any | undefined;
  @Input() programs: any;
  @Output() programsChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() currentPage: any | undefined;
  @Input() trainingProgramCode: any | undefined;
  @Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>();

  vm: any = undefined;
  broadcastSubscriptions: Array<Subscription> = [];
  isMobileView: boolean;

  constructor() {
    this.vm = this;
  }

  ngOnInit() {
    this.vm.isMobileView = window.matchMedia('(max-width: 768px)').matches;
    this.vm.filter = {
      orderBy: 'start_date',
      ascending: false
    };
    this.vm.pageSize = this.vm.pageSize || 10;
    this.vm.currentPage = this.vm.currentPage || 0;
    this.vm.endReached = false;
    this.vm.loading = true;
    this.vm.editingEndDateIndex = null;
    this.vm.minEndDate = moment().add(1, 'day').toDate();

    this.loadPrograms(true, true);

    this.vm.loadPrograms = this.loadPrograms;
    this.vm.loadKpis = this.loadKpis;
    this.vm.setFilter = this.setFilter;
    this.vm.deleteProgramCampaign = this.deleteProgramCampaign;
    this.vm.compareDates = this.compareDates;
    this.vm.truncate = this.truncate;
    this.vm.getPercentageForProgress = this.getPercentageForProgress;
    this.vm.getProgramStatus = this.getProgramStatus;
    this.vm.toggleEditing = this.toggleEditing;
    this.vm.saveNewEndDate = this.saveNewEndDate;
    this.vm.cancelEdit = this.cancelEdit;
    this.vm.getCompletedRatio = this.getCompletedRatio;
    this.vm.getCoverage = this.getCoverage;
    this.vm.openTrainingAnalytics = this.openTrainingAnalytics;
  }

  ngOnDestroy() {
    for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
      this.broadcastSubscriptions[b].unsubscribe();
    }
  }

  loadPrograms(isInitial?, hasLoader?) {
    if (isInitial) {
      this.vm.endReached = false;
    } else if (this.vm.endReached) {
      this.vm.loading = false;
      return;
    }
    var params: any = {
      pageSize: this.vm.pageSize * 2,
      start: (!isInitial && this.vm.programs) ? this.vm.programs.length : 0,
      orderBy: this.vm.filter.orderBy || 'start_date',
      ascending: this.vm.filter.ascending || false
    };

    this.businessRestServices.getTrainingPrograms(params, (programs) => {
      if (programs && programs.length < this.vm.pageSize * 2) {
        this.vm.endReached = true;
      }
      if (isInitial) this.vm.currentPage = 0;
      if (hasLoader) {
        this.angularHelperService.createTimer(() => {
          this.vm.loading = false;
          this.vm.programs = isInitial ? programs : this.vm.programs.concat(programs);
          this.programsChange.emit(this.vm.programs);
          this.loadKpis();
        }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
      } else {
        this.vm.programs = isInitial ? programs : this.vm.programs.concat(programs);
        this.programsChange.emit(this.vm.programs);
        this.loadKpis();
      }
    });
  }

  loadKpis() {
    if (!this.vm.programs) return;
    this.vm.programs.forEach((p) => {
      if (!p || p.kpiLoading) return;
      p.kpiLoading = true;
      this.businessRestServices.getTrainingProgramKpi({ id: p.id }, (kpi) => {
        p.kpi = kpi || null;
        p.kpiLoading = false;
      }, () => {
        p.kpiLoading = false;
      });
    });
  }

  deleteProgramCampaign(programCampaign) {
    if (!programCampaign || programCampaign.processing) return;

    var dialog = this.dialogServices.confirmation({
      title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
      content: this.angularFilterHelperService.translate('Training.Table.Confirm_Delete')
          .replace('%s', programCampaign.title || programCampaign.name || '')
    });
    dialog.afterClosed().subscribe((data) => {
      if (data) {
        programCampaign.processing = true;
        var handleUpdate = () => {
          programCampaign.deleted = true;
          programCampaign.processing = false;
        };
        var errorCallback = (err) => {
          programCampaign.processing = false;
          console.log(err);
        }
        this.businessRestServices.deleteProgramCampaign({ programCampaignId: programCampaign.id }, handleUpdate, errorCallback);
      }
    });
  }

  compareDates(date) {
    var startDate = moment(date).toDate();
    var now = moment(new Date()).toDate();
    return now < startDate;
  }

  getPercentageForProgress(respondedCount, sentCount) {
    respondedCount = respondedCount ? respondedCount : 0;
    return Math.round((respondedCount * 100) / sentCount) + '%';
  }

  getCoverage(program: any): string {
    if (!program?.kpi) return '';
    return Math.round(program.kpi.coveragePct || 0) + '%';
  }

  getCompletedRatio(program: any): string {
    if (!program?.kpi) return '';
    const completed = program.kpi.completed || 0;
    const assigned = program.kpi.assignedManagers || 0;
    return `${completed}/${assigned || '-'}`;
  }

  getProgramStatus(program) {
    if (program && program.status) {
      return this.getProgramStatusLabel(program.status);
    }
    return '';
  }

  getProgramStatusLabel(status) {
    const normalizedStatus = (status || '').toString().toLowerCase();
    if (normalizedStatus === 'active') return this.angularFilterHelperService.translate('Training.Status.Active');
    if (normalizedStatus === 'completed') return this.angularFilterHelperService.translate('Training.Status.Completed');
    if (normalizedStatus === 'closed') return this.angularFilterHelperService.translate('Training.Status.Closed');
    if (normalizedStatus === 'scheduled') return this.angularFilterHelperService.translate('Training.Status.Scheduled');
    return status || '';
  }

  setFilter(name) {
    this.vm.filter = this.vm.filter || {};
    this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
    this.vm.filter.orderBy = name;
  }

  truncate(text, size) {
    if (!text) return '';
    return text.length > size ? text.slice(0, size - 1) + "…" : text;
  }

  toggleEditing(index: number) {
    this.vm.editingEndDateIndex = index;
  }

  saveNewEndDate(campaign: any, newEndDate) {
    this.vm.editingEndDateIndex = null;
    this.vm.loading = true;

    var params: any = {
      endDate: moment(newEndDate).format('YYYYMMDD'),
      campaignId: campaign.id
    };
    this.updateCampaign(params);
  }

  updateCampaign(params: any) {
    this.businessRestServices.updateProgramCampaign(params)
        .then((response) => {
          this.vm.loading = false;
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          this.vm.loading = false;
        });
  }

  cancelEdit() {
    this.vm.editingEndDateIndex = null;
  }

  openTrainingAnalytics(program) {
    if (!program?.id) return;
    this.router.navigate(['/training-programs', program.id, 'analytics']);
  }
}
